import { redirect } from "react-router-dom";
import { CHILD_ROUTES, INDEX_ROUTES } from "../../app/constants";
export const loader = async () => {
  // Handle special case for Legacy URL for workers compensation documents
  // This is because the old path included the string "workers-compensation"
  // and the new path is only "/documents" which ends up being "/workers-compensation/documents"
  if (window.location.pathname === CHILD_ROUTES.LEGACY_WORKERS_COMPENSATION_DOCUMENTS) {
    return redirect(
      `${INDEX_ROUTES.WORKERS_COMPENSATION}${CHILD_ROUTES.WORKERS_COMPENSATION_DOCUMENTS}`
    );
  }
  // Prepend /workers-compensation to legacy routes and redirect so that old URLs are not broken
  return redirect(`${INDEX_ROUTES.WORKERS_COMPENSATION}${window.location.pathname}`);
};
